// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var Teams = function Teams(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M6.877 2.414a2.63 2.63 0 101.18.968 2.63 2.63 0 00-1.18-.968zM12.08 4.809a2 2 0 101.082.8 2.001 2.001 0 00-1.083-.8zM9.74 13.133a.76.76 0 00-.75-.75h-5a.198.198 0 01-.14-.34.26.26 0 01.15-.07h4.9a.75.75 0 00.75-.71v-1.14a.82.82 0 00-.27-.59v-.01A5.74 5.74 0 000 13.974h9.74zM14.88 11.254a4.49 4.49 0 00-4.83-1.28h.01v1.28a.76.76 0 00.75.75h1.92a.2.2 0 01.21.2.21.21 0 01-.21.21h-1.92a.76.76 0 00-.75.75v.81H16a4.33 4.33 0 00-.24-1.2 4.49 4.49 0 00-.88-1.52z"
    }))
  );
};

export default Teams;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Teams.js
// module id = 1055
// module chunks = 0